import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  forgetMe,
  loginSuccess,
  rememberMe,
} from "../../redux/actions/Actions";
import { adminLogin, forgotPassword } from "../../services/auth.service";
import Swal from "sweetalert2";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading2, setIsLoading2] = useState(false);
  const { rememberedUsername, rememberedPassword, token } = useSelector(
    (state) => state?.auth
  );

  const {
    register,
    reset,
    getValues,
    handleSubmit: handleSubmitSignIn,
    setValue,
    formState: { errors },
  } = useForm();

  const [isRememberedMe, setIsRememberedMe] = useState(
    rememberedUsername ? true : false
  );

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    if (rememberedUsername && rememberedPassword) {
      setValue("username", rememberedUsername);
      setValue("password", rememberedPassword);
      setIsRememberedMe(true);
    }
    if (token) {
      navigate("/dashboard");
      // console.log(token);
    }
  }, [rememberedUsername, rememberedPassword, setValue]);

  const signIn = async (item) => {
    setIsLoading2(true);

    try {
      if (item.rememberMe) {
        dispatch(rememberMe(item.username, item.password));
      } else {
        dispatch(forgetMe());
      }

      const data = {
        email: item.username,
        password: item.password,
        role: "Admin",
      };

      const res = await adminLogin(data);

      if (res && res.status >= 200 && res.status < 300) {
        const token = res.data.token;
        dispatch(loginSuccess(token));
        navigate("/dashboard");
      } else if (res && res.status >= 400 && res.status < 500) {
        const errorMessage =
          res?.data?.error || "Invalid credentials. Please try again.";
        Swal.fire("Login Failed!", errorMessage, "error");
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected server error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during login:", error);
      Swal.fire(
        "Error",
        "Unable to complete the login process. Please check your connection and try again.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };

  const forgotPass = async () => {
    const email = getValues("username"); // Get the email from the email field

    if (!email) {
      alert("Please enter your email in the email field.");
      return;
    }

    const data = {
      email: email,
    };

    try {
      const res = await forgotPassword(data);
      if (res && res.status >= 200 && res.status < 300) {
        alert("Password reset instructions have been sent to your email.");
      } else if (res && res.status >= 400 && res.status < 500) {
        alert(res?.data?.message || "Invalid email address.");
      } else {
        alert("An unexpected error occurred. Please try again.");
      }
    } catch (error) {
      console.error("Error during forgot password process:", error);
      alert("A network or server error occurred. Please try again.");
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="authincation mt-5 flex-grow-1">
        <div className="container h-100">
          <div className="row justify-content-center h-100 align-items-center">
            <div className="col-md-6">
              <div className="authincation-content">
                <div className="row no-gutters">
                  <div className="col-xl-12">
                    <div className="">
                      <div className="text-center">
                        <Link to="index-2.html">
                          <img
                            className="logo-abbr w-50"
                            src="/assets/images/kidskart/logo1.gif"
                            alt=""
                          />
                        </Link>
                      </div>
                      <div className="auth-form">
                        <form
                          id="signIn"
                          name="signIn"
                          onSubmit={handleSubmitSignIn(signIn)}
                        >
                          {" "}
                          {/* onSubmit={handleSubmitSignIn(signIn)} */}
                          <div className="form-group">
                            <label className="mb-1">
                              <strong>Email</strong>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Email"
                              {...register("username", {
                                required: "Enter Email",
                              })}
                              maxLength={50}
                            />
                            {errors.username && (
                              <p className="error">{errors.username.message}</p>
                            )}
                          </div>
                          <div className="form-group position-relative">
                            <label className="mb-1 mt-1">
                              <strong>Password</strong>
                            </label>
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control"
                              placeholder="Enter Password"
                              {...register("password", {
                                required: "Enter Password",
                              })}
                              maxLength={20}
                            />
                            {errors.password && (
                              <p className="error">{errors.password.message}</p>
                            )}
                            {/* <span className="show-pass eye">
                              <i className="fa fa-eye-slash"></i>
                              <i className="fa fa-eye"></i>
                            </span> */}
                            <span
                              className="show-pass eye"
                              onClick={togglePasswordVisibility}
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                className={`fa ${
                                  showPassword ? "fa-eye" : "fa-eye-slash"
                                }`}
                              ></i>
                            </span>
                          </div>
                          <div className="form-row d-flex justify-content-between mt-4 mb-2">
                            <div className="form-group">
                              <div className="form-check custom-checkbox ms-1">
                                <input
                                  type="checkbox"
                                  className="form-check-input mt-1"
                                  id="rememberMe"
                                  {...register("rememberMe")}
                                  checked={isRememberedMe}
                                  onChange={() =>
                                    setIsRememberedMe(!isRememberedMe)
                                  }
                                />
                                <label
                                  className="custom-control-label ms-1"
                                  style={{ marginTop: "2px" }}
                                  htmlFor="rememberMe"
                                >
                                  Remember me
                                </label>
                              </div>
                            </div>
                            {/* <div
                              className="forgot-password"
                              style={{ marginTop: "2px" }}
                              onClick={() => forgotPass()}
                            >
                              Forgot Password?
                            </div> */}
                          </div>
                          <div className="text-center mb-5">
                            {!isLoading2 ? (
                              <button
                                type="submit"
                                className="btn btn-primary btn-block"
                              >
                                SIGN IN
                              </button>
                            ) : (
                              <button
                                disabled
                                type="button"
                                className="btn btn-primary btn-block"
                              >
                                SIGNING IN...
                              </button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="bg-light text-center py-3 mt-auto">
        <div className="container">
          <p className="mb-0">
            KidsKart Powered By <strong>BHARAT KUMAR MOTILAL & CO</strong>.
          </p>
        </div>
      </footer>
    </div>
  );
}
